export default __webpack_public_path__ + "ac2d4ae5b2fd20865052534023b23a28.png";